import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "siem",
  "use": "siem-usage",
  "viewBox": "0 0 16 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 14\" id=\"siem\"><path d=\"M3 11h10a2 2 0 002-2V2a2 2 0 00-2-2H3a2 2 0 00-2 2v7a2 2 0 002 2zm-.5-9a.5.5 0 01.5-.5h10a.5.5 0 01.5.5v7a.5.5 0 01-.5.5H3a.5.5 0 01-.5-.5zM10 12v.5a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5V12H0v1a1 1 0 001 1h14a1 1 0 001-1v-1z\" /><path d=\"M6 5.28a1 1 0 00-2 0V9h2zM9 7.82a1 1 0 00-2 0V9h2zM12 6.77a1 1 0 00-2 0V9h2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id